import React from 'react';
import {PageBodyTypes} from './types';
import {PageHeader} from "../page-header/page-header";
import {classNames} from "../../utils";

export const PageBody = ({
                             title = "",
                             titleStatus,
                             infoText,
                             filterAction,
                             filters,
                             noAction = false,
                             newAction,
                             newActionTitle,
                             secondaryAction,
                             secondaryActionTitle,
                             exportAction,
                             exportStatus,
                             exportActionTitle,
                             children,
                             noMargin = false,
                             exportAction2,
                               exportStatus2,
                               exportActionTitle2
                         }: PageBodyTypes) => {
    return (
        <main className="flex-1">
            <div className={noMargin ? "py-0" : "py-8"}>
                <PageHeader
                    title={title}
                    titleStatus={titleStatus}
                    filterAction={filterAction}
                    filters={filters}
                    newAction={newAction}
                    noAction={noAction}
                    newActionTitle={newActionTitle}
                    secondaryAction={secondaryAction}
                    secondaryActionTitle={secondaryActionTitle}
                    exportAction={exportAction}
                    exportStatus={exportStatus}
                    exportActionTitle={exportActionTitle}
                    hasInfo={!!infoText}
                    exportAction2={exportAction2}
                    exportStatus2={exportStatus2}
                    exportActionTitle2={exportActionTitle2}
                    
                />
                <div className={classNames(
                    noMargin ? "py-0" : "px-4 sm:px-6 md:px-8 mt-[8px]",
                    "mx-auto"
                )}>
                    <div className="py-4">{children}</div>
                </div>
            </div>
        </main>
    );
};
